import {Card} from "antd";

export const Cards = ({title,description}) => {
    return (
        <Card className={"rounded-lg text-center max-w-sm bg-white/70 backdrop-blur-sm"}>
            <h3 className={"text-xl text-cyan-800 font-bold pb-3"}>{title}</h3>
            <p className={"text-gray-600 font-semibold text-lg"}>{description}</p>
        </Card>
    )
}